export default class AudioControls {

    constructor() {
        if (this.audioElements = document.getElementsByTagName("audio")) {
            this.audioPlayButton = document.querySelectorAll(".audio-control-button")
            this._controlAudioFiles()
            this._preventParallelAudio()
        }
    }

    // control the play/pause buttons
    _controlAudioFiles() {
        for (let i = 0, l = this.audioPlayButton.length; i < l; i++) {
            this.audioPlayButton[i].addEventListener("click", function (e) {
                e.preventDefault()
                const audioElement = this.parentNode.querySelector('audio')

                if (audioElement.paused) {
                    this.classList.add("audio-control-button--playing")
                    return audioElement.play()
                }

                else {
                    this.classList.remove("audio-control-button--playing")
                    return audioElement.pause()
                }
            })
        }
    }

    // prevent multiple audio files from playing at the same time
    _preventParallelAudio() {
        const audioElements = this.audioElements
        document.addEventListener('play', function (e) {

            for (let i = 0, l = audioElements.length; i < l; i++) {
                if (audioElements[i] != e.target) {
                    audioElements[i].pause();
                    audioElements[i].nextElementSibling.classList.remove("audio-control-button--playing")
                }

                else {
                    audioElements[i].nextElementSibling.classList.add("audio-control-button--playing")
                }
            }
        }, true);
        this._audioEnded()
    }

    // if an audio file reached the end, show it's play button again
    _audioEnded() {
        for (let i = 0, l = this.audioElements.length; i < l; i++) {
            this.audioElements[i].addEventListener("ended", function () {
                this.nextElementSibling.classList.remove("audio-control-button--playing")
            })
        }
    }
}